import React, {useEffect, useState} from 'react';
import {List, ListItemButton, ListItemText, Menu, MenuItem, IconButton} from '@mui/material';
import PropTypes from 'prop-types';
import {bgColorDisabled, ezprOrange, txtColorDisabled} from '../../_helpers';
import {ThemeProvider} from '@mui/styles';
import {orangeTheme} from '../../_theme';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import CustomPopup from '../../dialogs/CustomPopup.jsx';
import Button from '@mui/material/Button';
import {requestStores} from '../../ListOfPREditors.brick.jsx';
import {PurchaseRequest} from '../../../models/PurchaseRequest';
import {TRANSPORT_OPTIONS_ENUM} from '../../../utils/constants.js';

// enable the functionality for supplier is different and via condition type when it's ready
const transportOptions = [
    {id: 0, label: 'No transport cost added', disabled: false, hidden: false},
    {id: 1, label: 'Via Material line - Same supplier', disabled: false, hidden: false},
    {id: 2, label: 'Via Material line - Supplier is different', disabled: true, hidden: true},
    {id: 3, label: 'Via Condition type', disabled: false, hidden: false},
];

/**
 * @param {LineItems.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function AddTransportCostComponent(props) {
    const styleBtn = {
        backgroundColor: (props.disabled || !props.userHasAccessToProperties) ? bgColorDisabled : ezprOrange,
        color: (props.disabled || !props.userHasAccessToProperties) ? txtColorDisabled : '#ffffff',
        borderColor: (props.disabled || !props.userHasAccessToProperties) ? bgColorDisabled : ezprOrange,
        padding: '5px 15px',
        borderRadius: '4px',
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(props.checked || 0);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const open = Boolean(anchorEl);
    const useRequestStore = requestStores.get(props.prTag);

    const removeTransportCostsConditionsForSelected = useRequestStore((state)=>state.removeTransportCostsConditionsForSelected);
    const removeTransportCostsConditions = useRequestStore((state)=>state.removeTransportCostsConditions);
    const deleteMaterial = useRequestStore((state)=>state.deleteMaterial);


    // if we click outside of the dialog the parent is cheking if it was closed without any interaction and will trigger the resetSelection to remove the selected transport cost
    useEffect(()=>{
        if ( props.resetSelection) {
            setSelectedIndex(0);
            setAnchorEl(null);
            props.onChange(0);
        }
    }, [props.resetSelection]);

    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setAnchorEl(null);
        props.onChange(index);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const disableSelection = props.disabled || !props.userHasAccessToProperties || selectedIndex !== 0;
    const tooltipText = disableSelection ? 'Please uncheck before selecting a new transport cost' : '';

    const showDeleteIcon = () => {
        if ( props.disabled ) {
            return <></>;
        }

        let renderDeleteIcon = false;
        switch (selectedIndex) {
        case TRANSPORT_OPTIONS_ENUM['No transport cost added']:
            renderDeleteIcon = false;
            break;
        case TRANSPORT_OPTIONS_ENUM['Via Material line - Same supplier']:
            renderDeleteIcon = true;
            break;
        case TRANSPORT_OPTIONS_ENUM['Via Material line - Supplier is different']:
            break;
        case TRANSPORT_OPTIONS_ENUM['Via Condition type']:
            if ( props.materials.length === 1) {
                renderDeleteIcon = true;
            } else if ( props.selectedMaterialIds.length > 0) {
                renderDeleteIcon = true;
            }
            break;
        }
        if (!renderDeleteIcon) {
            return <></>;
        }
        if (renderDeleteIcon) {
            return (
                <IconButton
                    component="span"
                    size={'small'}
                    onClick={()=>{
                        setShowDeleteConfirmation(true);
                    }}
                    style={{color: 'red'}}
                >
                    <DeleteIcon />
                </IconButton>
            );
        }
    };

    const handleDeleteConfirmation = () => {
        switch (selectedIndex) {
        case TRANSPORT_OPTIONS_ENUM['Via Material line - Same supplier']:
            const transportCostMaterial = PurchaseRequest.getTransportsCostsMaterial(props.materials);
            if (transportCostMaterial !== null) {
                deleteMaterial(transportCostMaterial.id);
            }
            setShowDeleteConfirmation(false);
            setSelectedIndex(0);
            setAnchorEl(null);
            props.onChange(0);
            break;
        case TRANSPORT_OPTIONS_ENUM['Via Material line - Supplier is different']:
            break;
        case TRANSPORT_OPTIONS_ENUM['Via Condition type']:
            if ( props.materials.length === 1) {
                removeTransportCostsConditions(()=>{
                    setShowDeleteConfirmation(false);
                });
                setSelectedIndex(0);
                setAnchorEl(null);
                props.onChange(0);
            } else if ( props.selectedMaterialIds.length > 0) {
                removeTransportCostsConditionsForSelected(props.selectedMaterialIds, (resetCondition)=>{
                    setShowDeleteConfirmation(false);
                    if (resetCondition) {
                        setSelectedIndex(0);
                        setAnchorEl(null);
                        props.onChange(0);
                    }
                });
            }
            break;
        }
    };
    return (
        <ThemeProvider theme={orangeTheme}>
            <Tooltip title={tooltipText} placement={'top'} arrow>
                <List
                    disabled={disableSelection}
                    component="nav"
                    aria-label="Transport Costs"
                    sx={{bgcolor: disableSelection ? bgColorDisabled : ezprOrange,
                        borderRadius: '4px',
                        borderColor: '#ffffff',
                        color: disableSelection ? txtColorDisabled : '#ffffff',
                        cursor: disableSelection ? 'default' : 'pointer',
                        boxSizing: 'border-box',
                        padding: '0px',
                        boxShadow: 'rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px'}}
                >
                    <ListItemButton
                        id="transport-button"
                        aria-haspopup="listbox"
                        aria-controls="transport-menu"
                        aria-label="when we added transport costs"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClickListItem}
                        disabled={disableSelection}
                        style={styleBtn}>
                        <ListItemText
                            primaryTypographyProps={{style: {fontSize: '14px', fontFamily: 'Roboto, Helvetica, Arial, sans-serif', fontWeight: '500'}}}
                            primary="ADD TRANSPORT COSTS"
                            secondaryTypographyProps={{style: {fontSize: '14px', fontFamily: 'Roboto, Helvetica, Arial, sans-serif'}}}
                            secondary={transportOptions[selectedIndex].id !== 0 && transportOptions[selectedIndex].label}
                        />
                    </ListItemButton>
                </List>
            </Tooltip>
            <Menu
                id="transport-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'transport-button',
                    'role': 'listbox',
                }}
            >
                {transportOptions.map((option) => {
                    if (!option.hidden) {
                        return (
                            <MenuItem
                                key={option.id}
                                disabled={option.disabled || option.id === selectedIndex}
                                selected={option.id === selectedIndex}
                                onClick={(event) => handleMenuItemClick(event, option.id)}
                                style={{...(option.id === 0 && {display: 'none'})}}
                            >
                                {option.label}
                            </MenuItem>
                        );
                    }
                })}
            </Menu>
            {showDeleteIcon()}
            {showDeleteConfirmation && (
                <CustomPopup
                    title='Delete selected items conditions?'
                    content='Are you sure you want to delete the selected items conditions?'
                    buttons={[
                        <Button
                            key={1}
                            onClick={() => {
                                setShowDeleteConfirmation(false);
                            }}
                            autoFocus
                        >
                         Cancel
                        </Button>,
                        <Button
                            key={2}
                            onClick={handleDeleteConfirmation}
                        >
                         Delete
                        </Button>,
                    ]}
                    open={showDeleteConfirmation}
                    handleClose={() => setShowDeleteConfirmation(false)}
                />
            )}
        </ThemeProvider>);
}

// checked is for the old functionality
AddTransportCostComponent.propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    checked: PropTypes.number,
    userHasAccessToProperties: PropTypes.bool,
    resetSelection: PropTypes.bool,
    selectedMaterialIds: PropTypes.array,
    prTag: PropTypes.string,
    materials: PropTypes.array,
};

